// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"02184cd1","124":"d835e1ce","324":"320cf33d","408":"46391512"}[chunkId] + ".chunk.js";
};